<template>
  <div v-if="!hiddenCart">
    <div class="navbar-tool ml-3">
      <el-button id="shopping-cart-drawer" :title="t('carts.shoppingCart')" link circle
        class="navbar-tool-icon-box bg-secondary dropdown-toggle" @click="triggerDrawer">
        <!-- <span id="cartCount" class="navbar-tool-label">{{ count }}</span> -->
        <el-badge v-if="count > 0" is-dot class="cart-badge">
          <i class="navbar-tool-icon czi-cart" style="line-height: 40px;"></i>
        </el-badge>
        <i v-else class="navbar-tool-icon czi-cart" style="line-height: 40px;"></i>
      </el-button>
      <div class="navbar-tool-text ml-2">
        <el-button :title="t('carts.shoppingCart')" link size="small" @click="triggerDrawer">
          {{ t('carts.shoppingCart') }}
        </el-button>
      </div>
    </div>

    <el-drawer v-model="state.drawer" :size="isMobile ? '95%' : 700" :show-close="false"
      :title="t('carts.shoppingCart')"
      modal-class="shopping-cart-drawer">
      <div v-loading="state.loading" :style="{ minHeight: '300px' }">
        <div v-if="count > 0">
          <div v-for="(event) in cartEventGroupsFormatted" :key="event.cart_group_key" class="mb-3">
            <div class="el-card__header text-primary">{{ event.cart_group_name }}</div>
            <div class="my-2 p-2 border border-primary rounded">
              <div v-for="(item, idx) in event?.items" :key="idx">
                <el-divider v-if="idx > 0" />
                <div class="d-flex w-100">
                  <div class="mr-2 d-flex flex-column" style="width: 60px; min-width: 60px;">
                    <cart-quantity-selector v-model="item.quantity" :min="item.min_order_quantity"
                      :max="item.max_order_quantity"
                      @change="(val) => changeQty({ cart_id: item.cart_id, quantity: val })" />
                    <a title="移除" href="javascript:void(0)" class="mt-auto mx-auto text-delete-cart"
                      @click="deleteCartWithConfirm(item)">
                      移除
                    </a>
                  </div>
                  <div class="d-flex w-100">
                    <div style="min-width: 70px;">
                      <a :title="item.product_name" :href="viewCartItem(item)">
                        <el-image :src="imgProxy(item.image_url, rs = 'fill:62:62:1')" :alt="item.product_name"
                          style="width: 62px; height: 62px; border: 1px solid #eef6ff;" class="rounded">
                          <template #error>
                          </template>
                        </el-image>
                      </a>
                    </div>

                    <div class="flex-fill">
                      <el-tag v-if="item?.hasErrorStatus" type="danger" effect="dark" size="small" class="mr-1">
                        {{ item.hasErrorStatus }}
                      </el-tag>

                      <el-tag v-else-if="item?.hasWarningStatus" type="warning" effect="dark" size="small" class="mr-1">
                        {{ item.hasWarningStatus }}
                      </el-tag>

                      <a :title="item.product_name" :href="viewCartItem(item)">
                        <div style="font-size: 14px;">
                          {{ item.product_name }}
                        </div>
                      </a>

                      <div class="d-none d-sm-block">
                        <small class="text-muted" style="font-size: 12px;">
                          {{ t("carts.options") }}:
                        </small>
                        <cart-assort-selector :data="item" :store-data="storeData" :dealer="dealer"
                          :is-subscribe="!!isSubscribe" @change="handleChangeAssort" />
                        <div v-if="!hiddenPrice" class="d-flex flex-wrap align-items-center">
                          <div class="text-accent mr-2">
                            {{ item.symbol }}
                            {{ n(item.discounted_price * item.quantity) }}
                          </div>
                          <div class="text-muted" style="font-size: 12px;">
                            <s>
                              {{ aliasTranslations?.comm_price || t("carts.commPrice") }}:
                              {{ item.symbol }}
                              {{ n(item.comm_price * item.quantity) }}
                            </s>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-sm-none w-100 mt-1">
                  <div class="d-flex align-items-center">
                    <small class="text-muted" style="font-size: 12px;min-width: 68px;">
                      {{ t("carts.options") }}:
                    </small>
                    <cart-assort-selector :data="item" :store-data="storeData" :dealer="dealer"
                      :is-subscribe="!!isSubscribe" @change="handleChangeAssort" />
                  </div>
                  <div v-if="!hiddenPrice" class="d-flex flex-wrap align-items-center justify-content-end">
                    <div class="text-accent mr-2">
                      {{ item.symbol }}
                      {{ n(item.discounted_price * item.quantity) }}
                    </div>
                    <div class="text-muted" style="font-size: 12px;">
                      <s>
                        {{ aliasTranslations?.comm_price || t("carts.commPrice") }}:
                        {{ item.symbol }}
                        {{ n(item.comm_price * item.quantity) }}
                      </s>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <EmptyCartImage v-else class="mt-5" />
        
        <!-- 加購商品 -->
        <AddonProductListVertical v-if="state.data" fields="assorts,assorts.image_url" search_from="carts"
          search_title="購物車" search_path="購物車>加購商品" :black-list="state.data?.carts || []"
          :currency-symbol="state.data?.currency_symbol" :store-data="storeData" @refresh:carts="getData" />
      </div>

      <CartBillTotal
        v-if="!hiddenPrice"
        v-model="form"
        :state="state.data"
        :data="state.data"
        :store-data="storeData"
        :cart-groups-formatted="cartGroupsFormatted"
        :cart-event-groups-formatted="cartEventGroupsFormatted"
        :coin-discount-limit="coinDiscountLimit"
        :delivery-fees="deliveryFees"
        :delivery-fees-discount="deliveryFeesDiscount"
        hide-delivery-fees
      />

      <template #header="{ close, titleId, titleClass }" class="pa-0">
        <div class="d-flex">
          <el-button title="關閉購物車" link class="align-self-center mx-3" @click="close">
            <i class="fa fa-close fa-2x" aria-hidden="true"></i>
          </el-button>
          
          <div class="pt-2 pb-1">
            <h3 :id="titleId" :class="titleClass">{{ t('carts.shoppingCart') }}</h3>
            <small v-if="storeData?.id" class="text-muted text-store-title">
              {{ dt(storeData?.name_translations) }}
            </small>
          </div>
          <div class="ml-auto align-self-center mr-3">
            <el-button :title="t('carts.continueShopping2')" type="primary" text class="p-0" :style="{ fontSize: '1.5rem' }" @click="triggerDrawer">
              {{ t('carts.continueShopping2') }}
            </el-button>
          </div>
        </div>
      </template>
      <template v-if="count > 0" #footer>
        <!-- <div class="text-left">
          <el-button type="primary" size="large" text class="p-0 mb-3" style="font-size: 2rem;" @click="triggerDrawer">
            {{ t("carts.continueShopping2") }}
          </el-button>
        </div> -->
        <div class="d-flex justify-content-between">
          <div class="text-left">
            <div v-if="!hiddenPrice" class="d-flex align-items-end">
              <strong class="mr-1 text-black-50" style="font-size: 1.5rem;line-height: 1.5rem;">
                總金額
              </strong>
              <span class="text-muted">費用</span>
            </div>

            <small class="text-primary">
              {{ t("carts.items", [count]) }}
            </small>
          </div>
          <div v-if="!hiddenPrice">
            <strong class="text-black-50" style="font-size: 1.5rem;">
              {{ state.data?.currency_symbol }}
              {{ currencyFormat(cartTotal) }}
            </strong>
          </div>
        </div>
        <div class="mt-2">
          <el-button v-if="checkAddon" title="加購商品不能單獨購買" type="danger" disabled size="large" class="btn-block">
            <!-- 購物車至少需要一個主要商品 -->
            🚫 加購商品不能單獨購買 ⛔
          </el-button>

          <!-- <el-button v-else-if="count > 0" type="primary" :disabled="!count || checkAddon" :loading="state.loading"
            size="large" class="btn-block btn-submit-cart" @click="handleGoUrl('/checkout')">
            {{ aliasTranslations?.checkout || t("carts.checkout") }}
          </el-button> -->
          <el-button v-else-if="count > 0" :title="aliasTranslations?.checkout || t('carts.checkout')" type="primary" :disabled="!count || checkAddon" :loading="state.loading"
            size="large" class="btn-block btn-submit-cart" @click="handleOpenCheckoutDialog()">
            {{ aliasTranslations?.checkout || t('carts.checkout') }}
          </el-button>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script setup>
import { reactive, onMounted, computed, ref } from 'vue'
import { useI18n } from "vue-i18n"
import { useStore } from 'vuex'
import { currencyFormat, dateFormat, dataTranslations as dt } from "../utils"
import { breakpoint, notificationErrors, assignCartCount, isBundlePromotionType, imgProxy, lookupAliasTranslations } from "../utils"
import CartQuantitySelector from "./checkout/CartQuantitySelector.vue"
import CartAssortSelector from "./checkout/CartAssortSelector.vue"
import AddonProductListVertical from "./products/AddonProductListVertical.vue"
import CartBillTotal from "./lites/checkout/CartBillTotal.vue"
import {
  _api_updateCartQty,
  _api_deleteCart,
  _api_getCartInfo,
  _api_createCart,
  _api_createCartGroup,
} from "../api/index.js";
import { ElLoading } from 'element-plus'
import EmptyCartImage from "./EmptyCartImage.vue";

const props = defineProps({
  storeData: Object,
  dealer: Object,
  isSubscribe: Number,
})
// const emit = defineEmits(['update:modelValue'])

const { t, n, locale } = useI18n()

const store = useStore()

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const checkAddon = computed(() => {
  const disabled = false
  if (state.data?.carts === undefined || !state.data?.carts.length) {
    return disabled
  }
  const hasAddon = state.data?.carts.findIndex((el) => el.ptype === "SADDT")
  const hasProd = state.data?.carts.findIndex((el) => el.ptype === "SPROD")
  // console.debug("hasAddon: ", hasAddon)
  // console.debug("hasProd: ", hasProd)
  if (hasAddon !== -1 && hasProd === -1) {
    return true
  }

  return disabled
})

// 紅利折抵上限
const coinDiscountLimit = computed(() => {
  let limit =
    assortRawTotal.value +
    deliveryFees.value -
    deliveryFeesDiscount.value -
    assortDiscount.value -
    promDiscount.value -
    promotionCodeDiscount.value;
  // console.debug("limit", limit)
  const account_shop_coin = state.data?.account_shop_coin || 0
  return account_shop_coin > limit ? limit : account_shop_coin;
});
// 組合原始總額
const assortRawTotal = computed(() =>
  state.data?.carts.reduce(
    (total, curr) => (total += curr.sale_price * curr.quantity),
    0
  )
);
// 網紅折扣
const assortDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    total += v.assort_discount;
  }
  return formatFloat(total, state.data?.currency_point);
});
// 活動折扣
const promDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    console.debug('promDiscount', v?.cart_group_name, v.prom_discount)
    total += v.prom_discount;
  }
  return formatFloat(total, state.data?.currency_point);
});

// 運費
const deliveryFees = ref(0)
// 運費折扣
const deliveryFeesDiscount = ref(0)

const promotionCodeDiscount = computed(() => {
  // 活動贈品不能使用購物金＆折扣碼
  if (hasPromGift.value) {
    return 0;
  }
  return state.discountCode && state.discountCode?.isAllowUse
    ? state.discountCode.amount
    : 0;
});
const hasPromGift = computed(() => {
  // 活動贈品不能使用購物金＆折扣碼
  const store_assort_ids = [];
  let hasPromGift = false;
  state.data?.promotions?.forEach((prom) => {
    for (const [k, v] of Object.entries(prom?.discountable_store_product_assorts_map)) {
      // console.debug(k, v)
      if (v?.activate_gift && v?.gift_items.length) {
        store_assort_ids.push(v?.store_assort_id);
      }
    }
  });
  // console.debug("hasPromGift: ", store_assort_ids)
  form.carts.forEach((cart) => {
    if (store_assort_ids.includes(cart.store_assort_id)) {
      hasPromGift = true;
    }
    // console.debug("cart: ", cart.store_assort_id)
  });
  return hasPromGift;
});
// 品質保障費
const insuranceFees = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    // console.log("cart_group_key: ", v.cart_group_key, v.insurance_fees)
    total += v.insurance_fees;
  }
  // console.log("insuranceFees: ", total)
  return formatFloat(total, state.data?.currency_point);
});
const subTotal = computed(() => {
  let total = 0
  if (!count.value) {
    return total
  }
  state.data?.carts.forEach((cart) => {
    total += cart?.discounted_price * cart?.quantity
  })
  return total - promDiscount.value
})

// 結帳總額
const cartTotal = computed(() => {
  // console.warn(`computed cartTotal ${new Date()}`);

  // 活動贈品不能使用購物金＆折扣碼
  let shopCoinDiscount = form.shop_coin_discount;
  if (hasPromGift.value) {
    shopCoinDiscount = 0;
  }

  let total =
    assortRawTotal.value +
    deliveryFees.value -
    deliveryFeesDiscount.value -
    shopCoinDiscount -
    assortDiscount.value -
    promDiscount.value -
    promotionCodeDiscount.value;
  
  // console.debug('assortRawTotal', assortRawTotal.value)
  // console.debug('deliveryFees', deliveryFees.value)
  // console.debug('deliveryFeesDiscount', deliveryFeesDiscount.value)
  // console.debug('shopCoinDiscount', shopCoinDiscount)
  // console.debug('assortDiscount', assortDiscount.value)
  // console.debug('promDiscount', promDiscount.value)
  // console.debug('promotionCodeDiscount', promotionCodeDiscount.value)

  return total;
});
const promotionMap = computed(() => _.keyBy(state.data?.promotions, "id"));

const cartEventGroupsFormatted = computed(() => {
  // console.warn(`computed cartEventGroupsFormatted ${new Date()}`);
  if (state.data?.carts === undefined || !state.data?.carts.length) {
    return {}
  }
  var start = 0;
  var end = 0;
  start = new Date().getTime();

  const grouped = _.groupBy(state.data.carts, (cart) => {
    return cart.event_group ? cart.event_group.event_group_uuid : null;
  });
  // console.log("by 活動: ", grouped)
  const formatted = _.reduce(
    grouped,
    (rst, val, key) => {
      // console.log("key:", key)
      // console.log("rst:", rst)
      const cartsCopy = _.cloneDeep(val);
      let cart = cartsCopy[0];
      let cart_group_name = t("carts.shoppingCart");

      let promotion = null;
      if (key && cart.event_group) {
        promotion = promotionMap.value?.[cart.event_group.event_id];
        if (promotion) {
          cart_group_name = promotion.title;
          if (
            promotion.min_amount_free_shipping &&
            promotion.min_amount_free_shipping !== null
          ) {
            cart_group_name += " (滿" + promotion.min_amount_free_shipping + "免運)";
          }
        } else {
          cart_group_name = "異常活動";
        }
      }

      let assort_count = 0; // 組合數量
      let assort_org_total = 0; // 組合 sale_price 總額
      let assort_org_total2 = 0; // 組合 comm_price 總額
      let assort_total = 0; // 組合 discounted_price 總額
      let assort_discount = 0; // 網紅折扣
      let assort_discount2 = 0; // 網紅折扣 (用 comm_price)
      let prom_discount = 0; // 活動折扣
      let discountable_store_product_assorts_map = promotion
        ? promotion.discountable_store_product_assorts_map
        : {};
      let choose_gifts = []; // 可選擇贈品
      let choose_gift_qty = 0; // 可選擇贈品數量

      cartsCopy.forEach((cart) => {
        // console.debug("cartEventGroupsFormatted 1:", cart.cart_id, cart.discounted_price)
        if (discountable_store_product_assorts_map[cart.store_assort_id]) {
          // 活動價
          cart.discounted_price =
            discountable_store_product_assorts_map[cart.store_assort_id].discounted_price;
          // 活動贈品
          if (
            discountable_store_product_assorts_map[cart.store_assort_id]?.activate_gift
          ) {
            cart.gift_items =
              discountable_store_product_assorts_map[cart.store_assort_id].gift_items;
          }
        }

        // console.debug("cartEventGroupsFormatted 2:", cart.cart_id, cart.discounted_price)
        
        assort_count += cart.quantity;
        assort_org_total += cart.sale_price * cart.quantity;
        assort_org_total2 += (cart.comm_price || cart.sale_price) * cart.quantity;
        assort_total += cart.discounted_price * cart.quantity;
      });
      assort_discount = assort_org_total - assort_total;
      assort_discount2 = assort_org_total2 - assort_total;

      if (promotion) {
        let prom_discount_info = getPromotionDiscount(
          promotion,
          assort_total,
          assort_count
        );
        if (isBundlePromotionType(promotion?.type)) {
          prom_discount_info = getBundleDiscount(promotion, cartsCopy);
        }
        prom_discount = prom_discount_info.prom_discount;
        choose_gifts = prom_discount_info.choose_gifts;
        choose_gift_qty = prom_discount_info.choose_gift_qty;
      }
      /*
      console.log('===============================')
      console.log('cart_group_name: ', cart_group_name)
      console.log('assort_count: ', assort_count)
      console.log('assort_org_total: ', assort_org_total)
      console.log('assort_total: ', assort_total)
      console.log('assort_discount: ', assort_discount)
      console.log('prom_discount: ', prom_discount)
      console.log('===============================')
      */

      rst[key] = {
        cart_group_key: key,
        cart_group_name: cart_group_name,
        items: cartsCopy,
        count: assort_count,
        assort_org_total: assort_org_total,
        assort_org_total2: assort_org_total2,
        assort_total: assort_total,
        assort_discount: assort_discount,
        assort_discount2: assort_discount2,
        prom_discount: prom_discount,
        prom_id: promotion ? promotion.id : null,
        choose_gifts: choose_gifts,
        choose_gift_qty: choose_gift_qty,
      };

      return rst;
    },
    {}
  );

  end = new Date().getTime();
  // console.debug("計算 活動: " + (end - start) / 1000 + " sec")
  // handleGroupsFormatted()

  return formatted;
});
const cartGroupsFormatted = computed(() => {
  // console.warn(`computed cartGroupsFormatted ${new Date()}`);
  if (state.data?.carts === undefined || !state.data?.carts.length) {
    return {}
  }
  var start = 0;
  var end = 0;
  start = new Date().getTime();
  // console.log("cartGroupsFormatted: ", state.data?)
  const grouped = _.groupBy(state.data.carts, (cart) => {
    cart.cart_group = cart.sup_co_id + "#" + cart.delivery_type + "#" + cart.temperature;
    
    return cart.cart_group;
  });
  // console.log("by 物流: ", grouped)
  const formatted = _.reduce(
    grouped,
    (rst, val, key) => {
      const cartsCopy = _.cloneDeep(val);
      let count = 0;
      let assort_total = 0;
      let assort_org_total = 0; // 組合 sale_price 總額
      let assort_org_total2 = 0; // 組合 comm_price 總額
      let insurance_assort_org_total = 0; // 售後保障組合原始總額

      let assort_discount = 0; // 網紅折扣
      let assort_discount2 = 0; // 網紅折扣 (用 comm_price)
      let prom_discount = 0; // 活動折扣
      let promotion_event_ids = [];
      let promotion = null;

      let event_assort_map = {}; // 紀錄活動組合總金額&數量
      let min_amount_free_shipping_list = []; // 免運門檻 (順序: 活動 -> 全站，取最低金額)

      let assort_total_non_excluded_discount = 0; // 計算全站免運用（要檢查 is_excluded_discount ）
      let delivery_fees_discount = 0; // 運費折扣
      let delivery_outer_island_fees_discount = 0; // 運費折扣 (外島)
      let amount_become_free_shipping = 0; // 還差多少金額免運

      cartsCopy.forEach((cart) => {
        if (
          cart.event_group &&
          !promotion_event_ids.includes(cart.event_group.event_id)
        ) {
          promotion_event_ids.push(cart.event_group.event_id);
          promotion = promotionMap.value[cart.event_group.event_id];
          // console.debug("promotion:", promotion?.is_excluded_outer_island_free_shipping)
        }
        let discountable_store_product_assorts_map = promotion
          ? promotion.discountable_store_product_assorts_map
          : {};
        // 活動價
        if (discountable_store_product_assorts_map[cart.store_assort_id]) {
          cart.discounted_price =
            discountable_store_product_assorts_map[cart.store_assort_id].discounted_price;
        }
        count += cart.quantity;
        assort_org_total += cart.sale_price * cart.quantity;
        assort_org_total2 += (cart.comm_price || cart.sale_price) * cart.quantity;
        assort_total += cart.discounted_price * cart.quantity;

        if (!cart.is_excluded_discount) {
          assort_total_non_excluded_discount += cart.discounted_price * cart.quantity;
          // // 先不改
          // if (promotion?.is_excluded_outer_island_free_shipping) {
          //   let delivery_type = key.split("_")[1];
          //   const isLogisticOuterIsland = state.isOuterIsland[delivery_type];
          //   if (!isLogisticOuterIsland) {
          //     assort_total_non_excluded_discount +=
          //       cart.discounted_price * cart.quantity;
          //   }
          // } else {
          //   assort_total_non_excluded_discount +=
          //     cart.discounted_price * cart.quantity;
          // }
        }
        // console.debug("cartGroupsFormatted:", cart.cart_id, cart.discounted_price)

        // 只計算非活動的商品
        if (!cart.event_group) {
          insurance_assort_org_total += cart.sale_price * cart.quantity;
        }

        if (cart.event_group && cart.event_group.event_id) {
          if (!event_assort_map[cart.event_group.event_id]) {
            event_assort_map[cart.event_group.event_id] = {
              assort_total: 0,
              count: 0,
            };
          }
          event_assort_map[cart.event_group.event_id].assort_total +=
            cart.discounted_price * cart.quantity;
          event_assort_map[cart.event_group.event_id].count += cart.quantity;
        }
      });
      assort_discount = assort_org_total - assort_total;
      assort_discount2 = assort_org_total2 - assort_total;

      if (promotion_event_ids.length) {
        promotion_event_ids.forEach((event_id) => {
          let event_assort_total = event_assort_map[event_id]
            ? event_assort_map[event_id].assort_total
            : 0;
          let event_count = event_assort_map[event_id]
            ? event_assort_map[event_id].count
            : 0;
          let promotion = promotionMap.value?.[event_id];
          if (promotion) {
            let prom_discount_info = getPromotionDiscount(
              promotion,
              event_assort_total,
              event_count
            );
            if (isBundlePromotionType(promotion?.type)) {
              prom_discount_info = getBundleDiscount(promotion, cartsCopy);
            }
            prom_discount += prom_discount_info.prom_discount;
            let event_total = event_assort_total - prom_discount_info.prom_discount;

            if (
              promotion.min_amount_free_shipping &&
              promotion.min_amount_free_shipping !== null
              // && event_total >= promotion.min_amount_free_shipping
            ) {
              min_amount_free_shipping_list.push(promotion.min_amount_free_shipping);
            }
          }
        });
      }

      // if (
      //   state.data?.free_delivery_amount_limit &&
      //   state.data?.free_delivery_amount_limit !== null
      // ) {
      //   min_amount_free_shipping_list.push(
      //     state.data?.free_delivery_amount_limit
      //   );
      // }

      let min_amount_free_shipping = null;
      if (min_amount_free_shipping_list.length > 0) {
        min_amount_free_shipping = Math.min(...min_amount_free_shipping_list);
      }

      let cart = cartsCopy[0];
      let cart_group_name = null;
      if (cart.delivery_type) {
        cart_group_name =
          cart.sup_co_name +
          "。" +
          logisticMap.value[cart.delivery_type].name +
          "。" +
          TEMPERATURE_I18N.value[cart.temperature];
      }

      // 售後保障費
      const insurance_fees = formatFloat(
        insurance_assort_org_total * 0.1,
        state.data?.currency_point
      );

      // console.debug("cartGroupsFormatted: ", cart)
      // console.debug("promotion:", promotion?.is_excluded_outer_island_free_shipping)
      // console.debug("min_amount_free_shipping:", assort_total, min_amount_free_shipping)
      if (promDiscount.value) {
        // 全站免運門檻還要再扣掉“活動折扣”
        assort_total_non_excluded_discount -= promDiscount.value;
        if (assort_total_non_excluded_discount < 0) {
          assort_total_non_excluded_discount = 0;
        }
      }

      // console.warn("min_amount_free_shipping", min_amount_free_shipping);
      // console.warn("assort_total", assort_total);
      // console.warn("free_delivery_amount_limit", state.data?.free_delivery_amount_limit);
      // console.warn("assort_total_non_excluded_discount", assort_total_non_excluded_discount);
      if (
        (min_amount_free_shipping !== null) &
        (assort_total - promDiscount.value >= min_amount_free_shipping)
      ) {
        delivery_fees_discount = calcDeliveryFees(cart.delivery_type);
      } else {
        // 全站免運（檢查不適用其他折扣）
        if (
          state.data?.free_delivery_amount_limit &&
          state.data?.free_delivery_amount_limit !== null &&
          assort_total_non_excluded_discount >= state.data?.free_delivery_amount_limit
        ) {
          delivery_fees_discount = calcDeliveryFees(cart.delivery_type);
        }
      }

      if (
        !promotion?.is_excluded_outer_island_free_shipping &&
        (min_amount_free_shipping !== null) & (assort_total >= min_amount_free_shipping)
      ) {
        delivery_outer_island_fees_discount = calcDeliveryOutIslandFees(
          cart.delivery_type
        );
      } else {
        // 全站免運（檢查不適用其他折扣）
        if (
          state.data.free_delivery_amount_limit &&
          state.data.free_delivery_amount_limit !== null &&
          assort_total_non_excluded_discount >= state.data.free_delivery_amount_limit
        ) {
          delivery_outer_island_fees_discount = calcDeliveryOutIslandFees(
            cart.delivery_type
          );
        }
      }

      // 還差多少免運
      if (!delivery_fees_discount) {
        if (
          (min_amount_free_shipping !== null) &
          (assort_total - promDiscount.value < min_amount_free_shipping)
        ) {
          amount_become_free_shipping =
            min_amount_free_shipping - assort_total + promDiscount.value;
        }
        if (!amount_become_free_shipping) {
          if (
            state.data.free_delivery_amount_limit &&
            state.data.free_delivery_amount_limit !== null &&
            assort_total_non_excluded_discount < state.data.free_delivery_amount_limit
          ) {
            amount_become_free_shipping =
            state.data.free_delivery_amount_limit - assort_total_non_excluded_discount;
          }
        }
      }
      console.debug("免運門檻 amount_become_free_shipping", amount_become_free_shipping);

      rst[key] = {
        cart_group_key: key,
        cart_group_name: cart_group_name,
        sup_co_id: cart.sup_co_id,
        delivery_type: cart.delivery_type,
        temperature: cart.temperature,
        items: cartsCopy,
        count: count,
        assort_total: assort_total,

        assort_org_total: assort_org_total,
        assort_org_total2: assort_org_total2,
        assort_discount: assort_discount,
        assort_discount2: assort_discount2,
        prom_discount: prom_discount,

        delivery_fees: calcDeliveryFees(cart.delivery_type),
        delivery_fees_discount: delivery_fees_discount,
        amount_become_free_shipping, // 還差多少金額免運

        delivery_outer_island_fees: calcDeliveryOutIslandFees(cart.delivery_type),
        delivery_outer_island_fees_discount: delivery_outer_island_fees_discount,
        // delivery_outer_island_fees_discount:
        //   !promotion?.is_excluded_outer_island_free_shipping &&
        //   (min_amount_free_shipping !== null) &
        //     (assort_total >= min_amount_free_shipping)
        //     ? calcDeliveryOutIslandFees(cart.delivery_type)
        //     : 0,
        insurance_assort_org_total: insurance_assort_org_total,
        insurance_fees: insurance_fees,
      };
      return rst;
    },
    {}
  );

  end = new Date().getTime();
  // console.debug("計算 物流: " + (end - start) / 1000 + " sec")

  return formatted;
});

const availablePaymentTypes = computed(() => {
  if (!state.data) {
    return [];
  }
  return state.data.payments.filter(
    (payment) => !["ECPAY.CREDIT_PERIOD"].includes(payment.type)
  );
});
const availableLogisticTypes = computed(() => {
  if (!state.data) {
    return [];
  }
  // 如果金流選了 (.+).COD 貨到付款（disabled其他物流）
  const selectedPaymentType = form.payment_type;
  if (selectedPaymentType && selectedPaymentType?.substr(-4) === ".COD") {
    const paymentCodLogisticType = selectedPaymentType.slice(0, -4);
    let matchedCODDeliveryType = paymentCodLogisticType;
    if (["PERSONALLY", "TCAT"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "HOME";
    } else if (["C2CUNIMART", "B2CUNIMART"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_UNIMART";
    } else if (["C2CFAMI", "B2CFAMI"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_FAMI";
    } else if (["C2CHILIFE", "B2CHILIFE"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_HILIFE";
    } else if (["C2COKMART", "B2COKMART"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_OKMART";
    }
    return state.data.logistics.map((logistic) => ({
      ...logistic,
      disabled: logistic.delivery_type !== matchedCODDeliveryType,
    }));
  }
  return state.data.logistics.map((logistic) => ({
    ...logistic,
    disabled: false,
  }));
});

const count = ref(0);
const hasError = ref(false); // disabled 結帳按鈕
const state = reactive({
  drawer: false,
  loading: false,
  discountCode: null,
  data: null,
  isOuterIsland: {},
})
const form = reactive({
  // 購買者
  buyer_name: null,
  buyer_mobile: null,
  buyer_email: null,
  // 收件者
  uads_id: 0,
  to_name: null,
  to_mobile: null,
  to_email: null,
  country: null,
  province: null,
  city: null,
  region: null,
  postal_code: null,
  address: null,
  // 金流
  payment_type: availablePaymentTypes.value.length
    ? availablePaymentTypes.value[0].type
    : null,
  // 寄送方式
  delivery_type: availableLogisticTypes.value.length
    ? availableLogisticTypes.value[0].delivery_type
    : null,
  // 發票
  invoice_print_mark: "N",
  invoice_type: "invoice",
  invoice_relation_option: "ORDER",
  invoice_relation_value: null,
  invoice_paper_no: null,
  invoice_paper_title: null,
  invoice_paper_relation_mobile: null,
  invoice_donate_code: "168001",
  invoice_province: null,
  invoice_city: null,
  invoice_region: null,
  invoice_postal_code: null,
  invoice_address: null,
  // 購物金
  shop_coin_discount: 0,
  memo: null,
  cvs_711_shop_id: null,
  cvs_711_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_family_shop_id: null,
  cvs_family_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_hilife_shop_id: null,
  cvs_hilife_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_okmart_shop_id: null,
  cvs_okmart_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  uads_address: true,
  uads_cvs_pcsc: true,
  uads_cvs_family: true,
  uads_cvs_hilife: true,
  uads_cvs_okmart: true,
  prom_code_id: null,
  carts: [],
  showToInfo: false,
});

const calcDeliveryFees = (delivery_type) => {
  // console.debug("calcDeliveryFees", delivery_type);
  if (!delivery_type) {
    return 0;
  }
  // console.log("calcDeliveryFees: ", delivery_type)
  const logistic = logisticMap.value[delivery_type];
  return logistic._fee_amount;
};
const calcDeliveryOutIslandFees = (delivery_type) => {
  // console.debug("calcDeliveryOutIslandFees", delivery_type);
  if (!delivery_type) {
    return 0;
  }
  const logistic = logisticMap.value[delivery_type];
  if (!logistic) {
    return 0;
  }
  const rate = logistic.rates.find((rate) => rate.countries.includes(form?.country));
  // console.debug("calcDeliveryOutIslandFees: ", delivery_type, rate)
  if (rate?.fees.length) {
    const fee = rate?.fees[0];
    if (fee?.is_open_outer_island) {
      return fee?.outer_island_fee_amount || 0;
    }
  }
  return 0;
};

const hasErrorStatus = (item) => {
  if (item.status == 'delete') {
    return t("carts.modelInvalid")
  } else if (item.status == 'event_delete') {
    return "異常活動"
  } else if (item.status == 'event_lower') {
    return "活動已下架或尚未開始"
  } else if (item.status != 'shelves') {
    return t("carts.ProductOff")
  } else if (!item.inventory || !item.max_order_quantity) {
    return "已售完"
  } else if (item.quantity > item.max_order_quantity) {
    return `已超過最大訂購上限 ${item.max_order_quantity}`
  }
  return null
}
const hasWarningStatus = (item) => {
  if (item.inventory < 10) {
    return t("carts.ProductRemaining", [item.inventory])
  }
  return null
}

const triggerDrawer = () => {
  state.drawer = !state.drawer
  if (state.drawer) {
    getData()
  }
}

const getData = async () => {
  state.loading = true
  try {
    state.data = await _api_getCartInfo()
    form.carts = state.data?.carts
    // console.debug("getData: ", state.data)
    count.value = localStorage.getItem('CART_COUNT') || 0
    // 離線tracker用
    const eventID = state.data?.headers?.["x-request-id"] ? state.data?.headers?.["x-request-id"] : null
    aibTrackers.viewCart(state.data, eventID)
    gtmTrackers.viewCart(state.data, eventID)
    fbqTrackers.viewCart(state.data, eventID)
    ttqTrackers.viewCart(state.data, eventID)
    gtagTrackers.viewCart(state.data, eventID)
  } catch (err) {
    notificationErrors(err)
  } finally {
    state.loading = false
  }
}
const handleGoUrl = (url) => {
  window.location.href = url
}

const handleOpenCheckoutDialog = () => {
  triggerDrawer();
  store.dispatch('lite/openCheckoutDialog');
}

// 計算任選數量
const getBundleDiscount = (promotion, carts = []) => {
  let prom_discount = 0 // 活動折扣

  const condition = promotion?.conditions?.[0]
  let obj = {
    prom_discount: formatFloat(prom_discount, state.data?.currency_point),
    choose_gifts: [],
    choose_gift_qty: 0,
  }
  if (!promotion || !condition || promotion?.condition_min_type != 'qty') return obj
  let bundles = []
  let cartsCopy = _.cloneDeep(carts)
  // 1. 排序金額(大到小)
  const sortCart = [...cartsCopy.sort((a, b) => b.discounted_price - a.discounted_price)]

  // 2. 拆解單筆商品數量
  cartsCopy = []
  sortCart.forEach((cart) => {
    for (let i = 0; i < cart.quantity; i++) {
      cartsCopy.push({ ...cart, quantity: 1 })
    }
  })
  // 3. 組合任選條件
  let assort_total = 0, discounted_price = 0, discount_amount = 0, discountable_quantity = 0
  bundles = _.chunk(cartsCopy, condition?.min_qty)
  for (const bundle of bundles) {
    if (bundle.length != condition?.min_qty) continue
    // console.debug("bundle", toRaw(bundle))
    bundle.forEach((cart) => {
      assort_total += cart.discounted_price
    })
    discounted_price += condition?.discounted_price
    discount_amount += condition?.discount_amount
    discountable_quantity += condition?.discountable_quantity
  }
  const discount_type = promotion?.discount_type
  let choose_gift_store_product_ids = []
  if (discount_type == "pricing") {
    // 固定金額
    prom_discount += assort_total - discounted_price
  } else if (discount_type == 'amount') {
    prom_discount = discount_amount
  } else if (discount_type == 'percentage') {
    prom_discount = assort_total * (condition.discount_percentage / 100)
  } else if (discount_type == 'gift') {
    choose_gift_store_product_ids = condition.discountable_store_product_ids
    obj.choose_gift_qty = discountable_quantity
  }
  const promDiscountableStoreProductMap = _.keyBy(promotion.discountable_store_products, "id")
  choose_gift_store_product_ids.forEach((store_product_id) => {
    const gift = promDiscountableStoreProductMap[store_product_id.toString()]
    if (gift) {
      obj.choose_gifts.push(gift)
    }
  })
  obj.prom_discount = formatFloat(prom_discount, state.data?.currency_point)
  return obj
}
const getPromotionDiscount = (promotion, assort_total, assort_count) => {
  let prom_discount = 0; // 活動折扣
  if (!promotion) return prom_discount;

  let discount_type = promotion.discount_type;
  let discount_value = null;
  let choose_gift_store_product_ids = [];
  let choose_gift_qty = 0;
  // console.debug('discount_type', discount_type)
  // console.debug('condition_min_type', promotion.condition_min_type)
  // 滿額
  if (promotion.condition_min_type == "amount") {
    for (const condition of promotion.conditions.sort(
      (a, b) => b.min_amount - a.min_amount
    )) {
      if (assort_total >= condition.min_amount) {
        if (discount_type == "amount") {
          discount_value = condition.discount_amount;
        } else if (discount_type == "percentage") {
          discount_value = condition.discount_percentage;
        } else if (discount_type == "gift") {
          choose_gift_store_product_ids = condition.discountable_store_product_ids;
          choose_gift_qty = condition.discountable_quantity;
        }
        break;
      }
    }
  }
  // 滿件
  else if (promotion.condition_min_type == "qty") {
    for (const condition of promotion.conditions.sort((a, b) => b.min_qty - a.min_qty)) {
      if (assort_count >= condition.min_qty) {
        if (discount_type == "amount") {
          discount_value = condition.discount_amount;
        } else if (discount_type == "percentage") {
          discount_value = condition.discount_percentage;
        } else if (discount_type == "gift") {
          choose_gift_store_product_ids = condition.discountable_store_product_ids;
          choose_gift_qty = condition.discountable_quantity;
        }
        break;
      }
    }
    
  }

  if (discount_type && discount_value) {
    if (discount_type == "amount") {
      prom_discount = discount_value;
    } else if (discount_type == "percentage") {
      prom_discount = assort_total * (discount_value / 100);
    }
  }

  const promDiscountableStoreProductMap = _.keyBy(
    promotion.discountable_store_products,
    "id"
  );
  let choose_gifts = [];
  choose_gift_store_product_ids.forEach((store_product_id) => {
    const gift = promDiscountableStoreProductMap[store_product_id.toString()];
    if (gift) {
      choose_gifts.push(gift);
    }
  });

  return {
    prom_discount: formatFloat(prom_discount, state.data?.currency_point),
    choose_gifts: choose_gifts,
    choose_gift_qty: choose_gift_qty,
  };
};

const handleChangeAssort = async (item) => {
  try {
    // 檢查現有購物車是否已有此組合
    const cart = state.data?.carts.find((el) => el?.store_product_id === item?.store_product_id && el?.store_assort_id === item?.new_store_assort_id)
    // 刪除原先的 cart_id
    await deleteCart(item)
    if (cart) {
      // 更新購物車數量
      // console.debug("更新購物車數量: ", cart)
      let quantity = item.quantity + cart.quantity
      if (quantity > item?.max_order_quantity) {
        quantity = item?.max_order_quantity
      }
      else if (quantity < item?.min_order_quantity) {
        quantity = item?.min_order_quantity
      }

      await changeQty({
        cart_id: cart.cart_id,
        quantity: quantity,
      })
    } else {
      // 加入購物車
      await addToCartByPayload(item)
    }
  } catch (error) {
    notificationErrors(error)
  }
}

const addToCartByPayload = async (item, redirect = false) => {
  const loading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  const storageName = item?.event_id ? "ADD_TO_CART_GROUP" : "ADD_TO_CART"
  let payload = {}

  try {
    // console.debug("加入購物車: ", item)
    const data = {
      store_product_id: item?.store_product_id,
      store_assort_id: item?.new_store_assort_id,
      quantity: item?.quantity,
      ptype: item?.ptype,
    }
    let res = null
    if (item?.event_id) {
      payload = {
        event_id: item?.event_id,
        event_type: item?.event_type,
        items: [data],
      }
      res = await _api_createCartGroup(payload)
    } else {
      payload = data
      res = await _api_createCart(payload)
    }

    localStorage.removeItem(storageName)
    const eventID = res?.headers?.["x-request-id"] ? state.data?.headers?.["x-request-id"] : null
    aibTrackers.addToCart(payload, null, eventID)
    gtmTrackers.addToCart(payload, null, eventID)
    fbqTrackers.addToCart(payload, null, eventID)
    ttqTrackers.addToCart(payload, null, eventID)
    gtagTrackers.addToCart(payload, null, eventID)

    toastr.success("成功更新購物車", {
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-top-right',
    });
    getData()
    assignCartCount(true)

  } catch (err) {
    // console.error("加入購物車失敗: ", payload)
    if (err?.errors) {
      const { type, msg } = err.errors[0]
      if (type == "RequireLoginError") {
        const temp = { "payload": payload, "redirect": redirect }
        localStorage.setItem(storageName, JSON.stringify(temp))
      } else {
        localStorage.removeItem(storageName)
      }
    }
    notificationErrors(err);
  } finally {
    loading.close();
  }
}

const deleteCartWithConfirm = (cart) => {
  swal
    .fire({
      title: "確認從購物車移除？",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: "#dd3333",
      cancelButtonColor: "#78909C",
      confirmButtonText: "確認移除",
      cancelButtonText: "按錯了!",
    })
    .then(async (result) => {
      if (result.value === true) {
        const loading = ElLoading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.5)',
        });
        try {
          const res = await _api_deleteCart(cart.cart_id)
          const eventID = res?.headers?.["x-request-id"] ? res?.headers?.["x-request-id"] : null
          aibTrackers.removeFromCart(cart, eventID)
          gtmTrackers.removeFromCart(cart, eventID)
          fbqTrackers.removeFromCart(cart, eventID)
          ttqTrackers.removeFromCart(cart, eventID)
          gtagTrackers.removeFromCart(cart, eventID)
          state.data.carts = state.data.carts.filter((el) => el.cart_id !== cart.cart_id)
          assignCartCount(true)
          // console.debug("deleteCart: ", cart)
        } catch (error) {
          notificationErrors(err);
        } finally {
          loading.close();
        }
      }
    });
};

const deleteCart = async (cart) => {
  const loading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  try {
    const res = await _api_deleteCart(cart.cart_id)
    const eventID = res?.headers?.["x-request-id"] ? res?.headers?.["x-request-id"] : null
    aibTrackers.removeFromCart(cart, eventID)
    gtmTrackers.removeFromCart(cart, eventID)
    fbqTrackers.removeFromCart(cart, eventID)
    ttqTrackers.removeFromCart(cart, eventID)
    gtagTrackers.removeFromCart(cart, eventID)
    state.data.carts = state.data.carts.filter((el) => el.cart_id !== cart.cart_id)
    assignCartCount(true)
    // console.debug("deleteCart: ", cart)
  } catch (error) {
    notificationErrors(err);
  } finally {
    loading.close();
  }
};

const changeQty = async (cart) => {
  if (cart.quantity === 0) {
    deleteCartWithConfirm(cart);
  } else {
    const loading = ElLoading.service({
      lock: true,
      background: 'rgba(0, 0, 0, 0.5)',
    });
    try {
      await _api_updateCartQty(cart.cart_id, cart.quantity)
      const index = state.data?.carts.findIndex((el) => el.cart_id === cart.cart_id)
      Object.assign(state.data.carts[index], cart)
    } catch (error) {
      notificationErrors(error);
    } finally {
      loading.close();
      assignCartCount(true)
    }
  }
};

const viewCartItem = (cart) => {
  if (!cart?.cart_id) {
    return
  }

  if (!cart?.event_group) {
    if (window.AIBWebsiteType === 'saas') {
      return `/apps/${cart?.store_product_id}`
    }
    return `/products/${cart?.store_product_id}`
  } else {
    const promotion = state.data?.promotions.find((p) => p.id === cart?.event_group?.event_id)
    // console.debug("promotion: ",promotion)
    if (promotion?.id) {
      return promotion?.is_open_group ? `/promotion-groups/${promotion.id}` : `/promotions/${promotion.id}`
    }
  }
  // console.debug("viewCartItem: ",cart)

  // window.location.href = url
  return "#"
}

onMounted(() => {
  count.value = localStorage.getItem('CART_COUNT') || 0
  window.addEventListener('CART_COUNT-localstorage-changed', (event) => {
    count.value = event.detail.storage;
    // console.log("CART_COUNT-t: ", event.detail.storage)
  });
  // console.debug("store: ", dt(props.storeData?.name_translations))
})
</script>

<style lang="scss">
.el-button {
  &.is-link {
    color: var(--primary_color);
  }
}

.shopping-cart-drawer {
  .el-drawer__header {
    padding: 0;
    margin-bottom: 0;
    border-bottom: 1px solid rgb(204, 204, 204);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    z-index: 1;
  }

  .el-drawer__title {
    font-size: 1.3rem;
    line-height: 1.3rem;
  }

  .el-drawer__body {
    padding: 0px 7px;
    overflow-y: scroll;
    overflow-x: hidden;
    scroll-behavior: auto;

    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0px;
      background-color: #fe696a !important;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px #EEEEEE !important;
    }
  }

  .el-drawer__footer {
    padding: 7px 10px 10px;
    border-top: 1px solid rgb(204, 204, 204);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    z-index: 1;
  }

  .el-divider {
    margin: 10px 0px;
  }

  .text-store-title {
    font-size: 1rem;
    font-weight: 800;
  }

  .text-delete-cart {
    font-size: 0.8rem;
  }

  .btn-submit-cart {
    font-size: 1.3rem;
  }

  .el-loading-mask {
    margin-top: 2px;
  }
}
</style>